import React from 'react';
import { Facebook, Instagram, Mail} from 'lucide-react';
import { socialLinks, sponsors, organisers } from '../../constants/navigation';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'About', href: '#about' },
    { label: 'Schedule', href: '#schedule' },
    { label: 'Workshops', href: '#workshops' },
    { label: 'Tickets', href: '#tickets' },
    { label: 'Featured Baterias', href: '#featured-baterias' },
    { label: 'Merch', href: '#merch'},
  ];

  return (
    <footer className="bg-primary-purple text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
          {/* About Section */}
          <div>
            <h3 className="text-xl font-bold mb-4">Adelaide Samba Encontro 2025</h3>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a 
                    href={link.href}
                    className="text-gray-300 hover:text-primary-yellow transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul><br/>
            <h3 className="text-xl font-bold mb-4">Contact Us</h3>
                <Mail className="w-5 h-5 mr-2 text-primary-yellow" />
                <a 
                  href="mailto:contact@adelaidesambaencontro.info" 
                  className="text-gray-300 hover:text-primary-yellow transition-colors duration-200"
                >contact@adelaidesambaencontro.info
                </a>
          </div>         

          {/* Social and Sponsors */}
          <div>
            <h3 className="text-xl font-bold mb-4">Connect With Us</h3>
            <div className="flex space-x-4 mb-6">
              <a 
                href={socialLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-primary-yellow transition-colors duration-200"
                aria-label="Facebook"
              >
                <Facebook className="w-6 h-6" />
              </a>
              <a 
                href={socialLinks.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-primary-yellow transition-colors duration-200"
                aria-label="Instagram"
              >
                <Instagram className="w-6 h-6" />
              </a>
            </div>

            <h4 className="font-bold mb-2">Our Sponsors</h4>
            <div className="grid grid-cols-2 gap-4">
              {sponsors.map((sponsor) => (
                <a
                  key={sponsor.name}
                  href={sponsor.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 rounded-lg hover:opacity-80 transition-opacity duration-200"
                >
                  <img 
                    src={sponsor.logo} 
                    alt={sponsor.name}
                    className="h-12 w-auto object-contain"
                  />
                </a>
              ))}
            </div><br></br>

            <h4 className="font-bold mb-2">Event organisers</h4>
            <div className="grid grid-cols-2 gap-4">
              {organisers.map((organisers) => (
                <a
                  key={organisers.name}
                  href={organisers.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 rounded-lg hover:opacity-80 transition-opacity duration-200"
                >
                  <img 
                    src={organisers.logo} 
                    alt={organisers.name}
                    className="h-24 w-auto object-contain"
                  />
                </a>
              ))}
            </div>            
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-300 text-sm">
              © {currentYear} Adelaide Samba Encontro. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;